import styled from 'styled-components'
import { Typography } from 'primsell-shared-layer/components'
import { baseTheme } from 'primsell-shared-layer/styles/theme'
import { Link } from 'primsell-shared-layer/components'
import { LinkTypography } from '../../atoms/link/link.styles'

export const StyledAgreedForm = styled.div`
  display: flex;
  flex-direction: column;

  & > div {
    display: flex;
    justify-content: start;
    align-content: center;
  }
`

export const StyledTypography = styled(Typography)`
  display: inline;
  margin-left: 10px;
  line-height: 17px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;

  & strong {
    color: ${baseTheme.colors.dark};
  }
`
export const StyledLink = styled(Link)`
  display: inline;
  ${LinkTypography} {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    display: inline;
    color: rgb(107, 114, 128);
    text-decoration: underline;

    & strong {
      color: ${baseTheme.colors.dark};
    }
  }
`
